import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

interface ProtectedRouteProps {
  children: React.ReactNode
  requiredTier?: 'free' | 'premium'
}

export default function ProtectedRoute({ children, requiredTier = 'free' }: ProtectedRouteProps) {
  const { isAuthenticated, user, isLoading } = useAuth()
  const location = useLocation()

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Check tier requirements
  if (requiredTier === 'premium' && user?.tier !== 'premium') {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center space-y-4">
          <h2 className="text-2xl font-bold text-foreground">Premium Required</h2>
          <p className="text-muted-foreground">
            This feature requires a premium subscription.
          </p>
          <a href="/pricing" className="btn btn-primary btn-md">
            Upgrade Now
          </a>
        </div>
      </div>
    )
  }

  return <>{children}</>
}